export const GET_ALL_ACTIVITY_LOG = 'GET_ALL_ACTIVITY_LOG';
